import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 54 — GoHighLevel expert hiring-platform comparison cluster service links.
 *
 * Every Batch 54 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch54Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH54_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-expert-hiring-platforms-comparison": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /marketplace freelancer who builds one workflow is not a dedicated architect who designs the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "upwork-vs-onlinejobs-gohighlevel-expert": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /\$40-an-hour Upwork freelancer with a 13\.5% conversion fee is not a \$600-a-month OnlineJobs\.ph hire/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-va-agency-vs-freelance-marketplace": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /marketplace freelancer who lists GoHighLevel on a profile is not a vetted VA who can architect/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-expert-cost-by-platform": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /\$40-an-hour freelancer with a 13\.5% conversion fee and a rework cycle is not a \$600-a-month direct hire/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
